import api from '@/soluqr/api/client';

/**
 * POST /menu/:businessId/delivery-quote — misma API que CheckoutPage.
 * @returns {Promise<{ delivery_fee?: number, distance_km?: number, within_radius?: boolean, distance_source?: string|null, detail?: string, pricing?: { base_price: number, min_km: number, per_km: number }|null }>}
 */
export async function requestMenuDeliveryQuote(businessId, lat, lng, options = {}) {
  const { signal } = options;
  const { data } = await api.post(
    `/menu/${businessId}/delivery-quote`,
    { lat, lng },
    signal ? { signal } : undefined
  );
  return data;
}
